<template>
  <b-modal
    @hidden="$emit('hidden')"
    modal-class="transactionModal" :dialog-class="isAPP ? 'transactionModal__dialog mx-auto' : ''"
    id="goTransactionModal" hideHeader hideFooter centered :noCloseOnBackdrop="noCloseOnBackdrop"
    noCloseOnEsc noEnforceFocus>
    <b-container v-if="securitiesFirm" class="px-0">
      <template v-if="is_login">
        <div
          :class="{
            'st_title-medium-big': !isAPP,
            'st_title-medium-base mt-n1': isAPP
          }">
          前往{{ transactionType }}頁面
        </div>
        <div
          :class="{
            'st_caption-regular-big text-center my-4 pb-2': !isAPP,
            'st_caption-regular-base d-flex align-items-center justify-content-center my-4': isAPP,
          }">
          <b-img class="transactionModal__img" :src="securitiesFirm.icon" fluid />
          {{ securitiesFirm.name }}
        </div>
        <div
          :class="{
            'mb-5': !isAPP,
            'mb-4': isAPP,
            'pb-2': isAPP && showLinks,
          }"
          class="st_heading-regular-base text-center">
          即將前往{{ convertTransactionModalText }}
        </div>
        <div v-if="isAPP && showLinks" class="d-flex flex-column align-items-center mx-2">
          <span class="st_caption-medium-small mb-4">
            (如未跳轉，請點擊下方前往下載 APP)
          </span>
          <div class="d-flex">
            <a :href="securitiesFirm.transactionURL.app.ios" class="mr-2">
              <b-img fluid :src="require('~/static/images/securitiesFirms/ios-app-store.png')" alt="" />
            </a>
            <a :href="securitiesFirm.transactionURL.app.android">
              <b-img fluid :src="require('~/static/images/securitiesFirms/google-play-badge.png')" alt="" />
            </a>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="st_title-medium-big text-center mt-3 mb-4">
          前往{{ convertTransactionModalText }}前<br>
          請先登入微股力
        </div>
        <div class="my-3">
          <a
            class="transactionModal__login text-white py-2 d-block mx-auto text-center"
            :href="user.loginUrl">
            <img src="/images/line-icon.png">
            登入 LINE 帳號
          </a>
        </div>
      </template>
    </b-container>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      securitiesFirm: {
        type:     Object,
        required: true,
      },
      noCloseOnBackdrop: {
        type:    Boolean,
        default: false,
      },
      transactionType: {
        type:     String,
        required: true,
      },
    },
    data () {
      return {
        showLinks: false,
      }
    },
    computed: {
      ...mapGetters(['user', 'is_login']),
      isAPP () {
        if (this.securitiesFirm.transactionURL && this.securitiesFirm.transactionURL.app) {
          return Object.values(this.securitiesFirm.transactionURL.app).some(val => val)
        }
        return false
      },
      convertTransactionModalText () {
        if (this.isAPP) {
          return ` ${this.securitiesFirm.name}${this.securitiesFirm.transactionURL.app.name || ' '}APP`
        }
        return `${this.securitiesFirm.name}下單網頁`
      },
    },
    timers: {
      downloadLink: {
        time: 1500,
      },
    },
    methods: {
      downloadLink () {
        this.showLinks = true
      },
    },
    mounted () {
      if (this.isAPP) this.$timer.start('downloadLink')
    },
  }
</script>

<style lang="scss">
  .transactionModal {
    &__dialog {
      max-width: 345px;
    }

    &__img {
      width: 40px;
      height: 40px;
    }

    &__remind {
      font-size: $st_font-size-small;
      color: $st_color_gray;
      letter-spacing: 0.7px;
    }

    &__login {
      background-color: #00c43e;
      border-radius: 2px;
      font-size: 17px;
      max-width: 250px;

      img {
        max-width: 26px;
      }
    }
  }
</style>
